import React, { Component } from 'react';
import { connect } from 'react-redux';
import './QuoteContainer.css';

import Quote from './Quote';
import QuoteController from './QuoteController';

class QuoteContainer extends Component {

	
	render(){
		
		let style = {
			backgroundColor: this.props.color	
		};

		return (
			<div className="quote-container">
				<Quote style={style} />
				<QuoteController style={style} />
			</div>
		);	
	}
}

const mapStateToProps = state => ({
	color: state.settings.color 
});

export default connect(mapStateToProps, null)(QuoteContainer);
